import { BadgeCheck, ClipboardCheck, ShieldCheck, RotateCcw, Headset } from 'lucide-react';
import { returnsLabel } from '../lib/terms';

/**
 * Badge copy from the store's real terms (MERCH-53): `seller` is the sfSeller feed
 * (lib/store/seller), whose `policies` carry the platform returns_warranty numbers.
 * No number is shown unless the feed supplies it; nothing promises more than the policy.
 */
export function trustItems(seller) {
  const p = (seller && seller.policies) || {};
  const returns = p.returns || null;
  const warranty = p.warranty || null;
  const days = returns && Number.isInteger(returns.return_days) ? returns.return_days : null;
  const doa = returns && Number.isInteger(returns.doa_days) && returns.doa_days > 0 ? returns.doa_days : null;
  const months = warranty && Number.isInteger(warranty.min_months) && warranty.min_months > 0 ? warranty.min_months : null;
  return [
    { icon: BadgeCheck, title: 'Verified seller', text: seller && seller.verifications && seller.verifications.length ? seller.verifications.map((v) => v.label).join(' · ') : 'Business details on record' },
    { icon: ClipboardCheck, title: 'Inspected unit', text: 'See the report on each product' },
    { icon: ShieldCheck, title: 'Warranty included', text: months ? `At least ${months} months, in writing` : 'Seller-backed, in writing' },
    {
      icon: RotateCcw,
      title: returnsLabel(seller),
      text: days == null ? 'Terms shown at checkout' : doa ? `Dead on arrival or not as described; DOA claims within ${doa} days` : 'Dead on arrival or not as described',
    },
    { icon: Headset, title: 'Local support', text: seller && seller.city ? `Repairs in ${seller.city}` : 'Repairs and support from the store' },
  ];
}

/** Refurbished-assurance strip (WEB-01). `compact` = icon + title only. */
export default function TrustBadges({ compact = false, seller = null }) {
  const items = trustItems(seller);
  return (
    <ul className={`grid gap-3 ${compact ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5'}`}>
      {items.slice(0, compact ? 4 : items.length).map(({ icon: Icon, title, text }) => (
        <li key={title} className="flex items-start gap-2">
          <Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-600" aria-hidden="true" />
          <div className="min-w-0">
            <div className="text-sm font-semibold leading-tight">{title}</div>
            {!compact ? <div className="text-xs opacity-70">{text}</div> : null}
          </div>
        </li>
      ))}
    </ul>
  );
}
